import {
  bidderByBreakpoint,
  adUnitKeyByCode,
  adUnitByKey,
  parseBidders,
  adUnitKeyByTwin,
  parseVideoBidders,
} from './parseBidders';
import { videoBidders } from '../constants/bidders';
import { adPath } from './adPath';
import { getSizesAtBreakpoint } from './getSizesAtBreakpoint';
import { getBreakpoint } from './getBreakpoint';

const log = window.tv2.utils.setupLog();

export function getBidderBreakpoint(breakpoint) {
  // We use small and medium for now
  const useSmall = ['base', 'small'].indexOf(breakpoint) !== -1;
  return useSmall ? 'small' : 'medium';
}

export function parseAdUnits(adUnitElements) {
  const adUnitElementArray = adUnitElements ? [].slice.apply(adUnitElements) : [];
  const adUnits = [];

  // if no elements detected, send an error. We assume that prebid is not loaded on ad-less pages
  if (!adUnitElementArray || !adUnitElementArray.length) {
    log.error(`Header bidding script detected no ad units using "${adUnitElements}"`, { adUnitElementArray });
    return adUnits;
  }

  const breakpoint = getBreakpoint();
  const bidderBreakpoint = getBidderBreakpoint(breakpoint);
  const bidderObj = bidderByBreakpoint(bidderBreakpoint);

  if (!bidderObj) {
    log.error('parseBidders: No bidder settings found for breakpoint', { breakpoint });
    return null;
  }

  adUnitElementArray.forEach((tag) => {
    const sizes = getSizesAtBreakpoint(tag, breakpoint);
    if (!sizes.length) { return; }

    const identifier = tag.getAttribute('data-ad');
    const path = adPath(identifier);
    const code = `/${path.join('/')}`;

    const adUnitKey = adUnitKeyByCode(code, bidderObj);
    const adUnit = adUnitByKey(adUnitKey, bidderObj);
    const bidders = parseBidders(adUnit);

    if (bidders && bidders.length) {
      adUnits.push({
        code,
        mediaTypes: {
          banner: { sizes },
        },
        bids: bidders,
      });
    }

    // Push a twin adunit to adunits array, if found in twinBidders
    const twinUnitKey = adUnitKeyByTwin(adUnitKey, bidderBreakpoint);
    if (!twinUnitKey) {
      return;
    }

    const twinUnit = adUnitByKey(twinUnitKey, bidderObj);
    const twinBidders = parseBidders(twinUnit);

    if (twinBidders && twinBidders.length) {
      adUnits.push({
        code: `${code}--${twinUnitKey}`,
        mediaTypes: {
          banner: { sizes },
        },
        bids: twinBidders,
      });
    }
  });
  return adUnits;
}

export function parseVideoUnits() {
  const videoUnits = ['Underside_Video_1'];

  return videoUnits.map((unit) => {
    const path = adPath(unit);
    const code = `/${path.join('/')}`;
    const adUnitKey = adUnitKeyByCode(code, videoBidders);
    const bids = parseVideoBidders(videoBidders[adUnitKey]);

    return {
      code,
      bids,
      mediaTypes: {
        video: {
          context: 'instream',
          playerSize: [640, 360],
        },
      },
    };
  });
}
